import { useEffect, useState } from 'react';
import { Box, Button, Typography, IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PoliticaPrivacidade from '../pages/PoliticaPrivacidade';
import TermosUso from '../pages/TermosUso';

const STORAGE_KEY = 'betterdog_cookie_consent_v1';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      // ignore
    }
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.snackbar,
        display: 'flex',
        justifyContent: 'center',
        px: 2,
        pb: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 900,
          width: '100%',
          bgcolor: 'background.paper',
          boxShadow: 3,
          borderRadius: 2,
          p: 2,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2">
            <strong>Cookies:</strong> usamos cookies e tecnologias semelhantes para melhorar sua experiência e
            oferecer nossos serviços. Ao continuar navegando, você concorda com nossa{' '}
            <Typography
              component="span"
              color="primary"
              sx={{ textDecoration: 'underline', fontSize: 'inherit', cursor: 'pointer' }}
              onClick={() => setShowPrivacy(true)}
            >
              Política de Privacidade
            </Typography>{' '}
            e nossos{' '}
            <Typography
              component="span"
              color="primary"
              sx={{ textDecoration: 'underline', fontSize: 'inherit', cursor: 'pointer' }}
              onClick={() => setShowTerms(true)}
            >
              Termos de Uso
            </Typography>
            .
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, alignSelf: { xs: 'stretch', sm: 'center' } }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleAccept}
            sx={{ minWidth: 120 }}
          >
            Aceitar
          </Button>
          <IconButton size="small" onClick={handleClose} aria-label="Fechar aviso de cookies">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
      <Dialog
        open={showPrivacy}
        onClose={() => setShowPrivacy(false)}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle>Política de Privacidade</DialogTitle>
        <DialogContent dividers>
          <PoliticaPrivacidade />
        </DialogContent>
      </Dialog>
      <Dialog
        open={showTerms}
        onClose={() => setShowTerms(false)}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle>Termos de Uso</DialogTitle>
        <DialogContent dividers>
          <TermosUso />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
